import { toggleFullscreen } from "@/tools/functions";
import highchartsMore from 'highcharts/highcharts-more';
import * as Highcharts from 'highcharts/highstock';
import * as Exporting from 'highcharts/modules/exporting';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
Exporting(Highcharts);
highchartsMore(Highcharts);
NoDataToDisplay(Highcharts);

export default {
    name: 'HighchartComponent',
    components: {
    },
    props: {
        showFullscreen: {
            type: Boolean,
            required: false,
            default: false
        },
        title: {
            type: String,
            required: true,
            default: ''
        },
        dataChart: {
            type: Object,
            required: false,
            default: () => {
                return {
                    chart: {
                        renderTo: 'HighchartComponentId_' + (Math.random() + 1).toString(36).substring(7),
                        reflow: true
                    },
                    exporting: {
                        enabled: true
                    },
                    rangeSelector: {
                        enabled: false
                    },
                    lang: {
                        noData: 'Sin datos'
                    }
                }
            }
        },
        //Property para que se pueda actualizar el gráfico en función al tamaño del splitpane que lo contiene
        updateHighchart: {
            type: Boolean,
            required: false,
            default: false
        },
        showPrint: {
            type: Boolean,
            required: false,
            default: false
        },
        exportName: {
            type: String,
            required: true,
            default: ''
        },
        onClick: {
            type: Function,
            reuired: false
        }
    },
    data() {
        return {
            idChart: 'HighchartComponentId_' + (Math.random() + 1).toString(36).substring(7),
            chartInstance: null,
            chartComponentId: 'chartComponentId_' + (Math.random() + 1).toString(36).substring(7),
            fullscreenIcon: 'fullscreen'
        }
    },
    mounted() {
        Highcharts.seriesTypes.line.prototype.drawLegendSymbol = Highcharts.seriesTypes.area.prototype.drawLegendSymbol;
        this.$el.addEventListener('resize', () => {
            this.chartInstance.redraw();
            this.chartInstance.reflow();
        });
        this.$el.addEventListener('keyup', e => {
            if (e.keyCode === 27) {
                this.switchFullscreenIcon()
            }
        });
        /* Standard syntax */
        document.addEventListener('fullscreenchange', () => {
            this.switchFullscreenIcon()
        })
        /* Firefox */
        document.addEventListener('mozfullscreenchange', () => {
            this.switchFullscreenIcon()
        })
        /* Chrome, Safari and Opera */
        document.addEventListener('webkitfullscreenchange', () => {
            this.switchFullscreenIcon()
        })
        /* IE / Edge */
        document.addEventListener('msfullscreenchange', () => {
            this.switchFullscreenIcon()
        });
        Highcharts.setOptions({
            lang: {
                loading: 'Cargando...',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                exportButtonTitle: "Exportar",
                printButtonTitle: "Importar",
                rangeSelectorFrom: "Desde",
                rangeSelectorTo: "Hasta",
                rangeSelectorZoom: "Período",
                downloadPNG: 'Descargar imagen PNG',
                downloadJPEG: 'Descargar imagen JPEG',
                downloadPDF: 'Descargar imagen PDF',
                downloadSVG: 'Descargar imagen SVG',
                printChart: 'Imprimir',
                resetZoom: 'Reiniciar zoom',
                resetZoomTitle: 'Reiniciar zoom',
                thousandsSep: ",",
                decimalPoint: '.'
            },
        });
        if (this.dataChart) {
            this.dataChart.chart.events = {};
            this.dataChart.chart.events.click = (event) => { this.$emit('onClick', event) }
        }
        this.chartInstance = Highcharts.stockChart(this.idChart, this.chartData || {
            chart: {
                renderTo: this.idChart,
                reflow: true
            },
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            rangeSelector: {
                enabled: false
            },
            lang: {
                noData: 'Sin datos'
            }
        });
    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        updateHighchart() {
            this.chartInstance ? this.chartInstance.reflow() : null;
        }
    },
    computed: {
        chartData() {
            if (this.dataChart) {
                return {
                    ...this.dataChart,
                    chart: {
                        ...this.dataChart.chart,
                        renderTo: this.idChart,
                        reflow: true
                    },
                }
            }
            return null;
        }
    },
    methods: {
        exportPDF() {
            this.chartInstance.exportChart({
                type: 'application/pdf',
                filename: `${this.exportName}`
            });
        },
        exportPNG() {
            this.chartInstance.exportChart({
                type: 'image/png',
                filename: `${this.exportName}`
            });
        },
        exportJPG() {
            this.chartInstance.exportChart({
                type: 'image/jpeg',
                filename: `${this.exportName}`
            });
        },
        fullscreen() {
            const highchartComponentElement = document.getElementById(this.chartComponentId);
            this.fullscreenIcon = toggleFullscreen(highchartComponentElement);
        },
        switchFullscreenIcon() {
            if (!document.fullscreenElement && !document.mozFullScreenElement &&
                !document.webkitFullscreenElement && !document.msFullscreenElement) {
                this.fullscreenIcon = 'fullscreen'
            } else {
                this.fullscreenIcon = 'fullscreen_exit'
            }
        },
        resetZoom() {
            this.chartInstance.zoomOut();
        },
        print() {
            this.chartInstance.print();
        }
    },
    destroyed() {
        this.chartInstance.destroy()
    }
}
